/**
 * Created by Alican Köker on 2019-06-09.
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { TimelineLite } from "gsap";

export class ScatterOverlayObject extends BaseView {

    private _scatterAnimation:PIXI.spine.Spine;
    private _scatterImage:PIXI.Sprite;
    private _container:PIXI.Sprite;
    private _timeline:TimelineLite;

    constructor() {
        super();
        this.init();
    }

    private init():void {
        const animPosX:number = EdisonGameConfig.instance.SYMBOL_WIDTH / 2 + 16;
        const animPosY:number = EdisonGameConfig.instance.SYMBOL_HEIGHT / 2 + 4;

        this._container = new PIXI.Sprite();
        this._scatterImage = new PIXI.Sprite(GameResources.getTextures("S/S")[0]);
        this._scatterImage.visible = true;
        this._scatterAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("scatter"));
        this._scatterAnimation.position.set(animPosX, animPosY);
        this._scatterAnimation.visible = true;
        this._container.visible = false;

        this._container.addChild(this._scatterImage);
        this._container.addChild(this._scatterAnimation);
    }

    public get container():PIXI.Sprite {
        return this._container;
    }

    /**
     * Animation names:
     * 'Initial' for landing,
     * 'Anticipation' for Scatter Anticipation
     * 'ThreeHit' for < 3 Scatters land and Freespin is won
     * */

    public playAnimation(animationName:string, continuous:boolean = false):TimelineLite {

        this._container.visible = true;
        this._timeline = new TimelineLite();

        this._scatterAnimation.visible = true;

        const animPosX:number = EdisonGameConfig.instance.SYMBOL_WIDTH / 2 + 16;
        const animPosY:number = EdisonGameConfig.instance.SYMBOL_HEIGHT / 2 + 4;

        this._scatterAnimation.position.set(animPosX, animPosY);

        this._timeline.add(() => {
            const trackEntry:PIXI.spine.core.TrackEntry = this._scatterAnimation.state.setAnimation(0, animationName, continuous);
            trackEntry.timeScale = animationName === "Initial" ? 2 : 1.3;
        }, .001);

        return this._timeline;
    }

    public stopAnimation():void {
        if(this._timeline) {
            this._timeline.pause();
            this._timeline.kill();
        }
        this._scatterAnimation.state.clearTracks();
        this._scatterAnimation.state.setEmptyAnimation(0, 0);
        this._scatterAnimation.skeleton.setToSetupPose();
    }

    public reset():void {
        this.stopAnimation();
        this._container.visible = false;
    }

    public dim():void{
        this._scatterImage.tint = 0x888888;
        this._scatterAnimation.tint = 0x888888;
    }

    public undim():void{
        this._scatterImage.tint = 0xffffff;
        this._scatterAnimation.tint = 0xffffff;
    }
}